'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CalculatorButtonGroup = require('pricing-pages-unified-ui/components/common/CalculatorButtonGroup');

var _CalculatorButtonGroup2 = _interopRequireDefault(_CalculatorButtonGroup);

var _EditionSelectionButton = require('pricing-pages-unified-ui/components/common/EditionSelectionButton');

var _EditionSelectionButton2 = _interopRequireDefault(_EditionSelectionButton);

var _Editions = require('self-service-api/constants/Editions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALL_EDITIONS = [_Editions.FREE, _Editions.STARTER, _Editions.PROFESSIONAL, _Editions.ENTERPRISE];

var EditionSelectionButtonGroup = function EditionSelectionButtonGroup(_ref) {
  var activeEdition = _ref.activeEdition,
      onEditionUpdated = _ref.onEditionUpdated,
      ownedEdition = _ref.ownedEdition;

  var editionsAlreadyOwned = ownedEdition ? ALL_EDITIONS.slice(0, ALL_EDITIONS.indexOf(ownedEdition)) : [];

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _CalculatorButtonGroup2.default,
      null,
      _react2.default.createElement(_EditionSelectionButton2.default, {
        key: _Editions.STARTER,
        edition: _Editions.STARTER,
        selected: activeEdition === _Editions.STARTER,
        disabled: editionsAlreadyOwned.includes(_Editions.STARTER),
        onClick: onEditionUpdated,
        currentPlan: ownedEdition === _Editions.STARTER
      }),
      _react2.default.createElement(_EditionSelectionButton2.default, {
        key: _Editions.PROFESSIONAL,
        edition: _Editions.PROFESSIONAL,
        selected: activeEdition === _Editions.PROFESSIONAL,
        disabled: editionsAlreadyOwned.includes(_Editions.PROFESSIONAL),
        onClick: onEditionUpdated,
        currentPlan: ownedEdition === _Editions.PROFESSIONAL
      }),
      _react2.default.createElement(_EditionSelectionButton2.default, {
        key: _Editions.ENTERPRISE,
        edition: _Editions.ENTERPRISE,
        selected: activeEdition === _Editions.ENTERPRISE,
        disabled: editionsAlreadyOwned.includes(_Editions.ENTERPRISE),
        onClick: onEditionUpdated,
        currentPlan: ownedEdition === _Editions.ENTERPRISE
      })
    )
  );
};

EditionSelectionButtonGroup.propTypes = {
  activeEdition: _react.PropTypes.string.isRequired,
  onEditionUpdated: _react.PropTypes.func.isRequired,
  ownedEdition: _react.PropTypes.string
};

exports.default = EditionSelectionButtonGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/EditionSelectionButtonGroup.js
// module id = 591
// module chunks = 3 4